import {
  COMPONENT_STATE_ARGS,
  CONTENT_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../../core/base.gjs';
import styles from './header.module.scss';

const METADATA = Metadata.define({
  description: 'Header section for the Card component with title, subtitle, and action slots',
  extends: [
    pick(COMPONENT_STATE_ARGS, [
      { name: 'hasBorder', description: 'Display a border below the header' },
    ]),
    pick(CONTENT_ARGS, ['subtitle', 'title']),
  ],
  name: 'Card Header',
});

export default class SpdsContainerCardHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-container-card-header';
  styles = styles;

  get hasBorder() {
    return this.argOrDefault('hasBorder');
  }

  <template>
    <FlexColumn
      @tag="header"
      class={{this.classes}}
      data-test-spds-container-card-header
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      <FlexRow class="spds-container-card-header-content-wrapper">
        <FlexColumn class="spds-container-card-header-content">
          <FlexRow
            class="spds-container-card-header-title"
            data-test-spds-container-card-header-title
          >
            {{#if @title}}
              <h2
                class="spds-container-card-header-title-text"
                data-test-spds-container-card-header-title-text
              >
                {{@title}}
              </h2>
            {{else if (has-block "title")}}
              {{yield to="title"}}
            {{/if}}
          </FlexRow>
          <FlexRow
            class="spds-container-card-header-subtitle"
            data-test-spds-container-card-header-subtitle
          >
            {{#if @subtitle}}
              <p
                class="spds-container-card-header-subtitle-text"
                data-test-spds-container-card-header-subtitle-text
              >
                {{@subtitle}}
              </p>
            {{else if (has-block "subtitle")}}
              {{yield to="subtitle"}}
            {{/if}}
          </FlexRow>
        </FlexColumn>
        {{#if (has-block "action")}}
          <FlexRow
            class="spds-container-card-header-action"
            data-test-spds-container-card-header-action
          >
            {{yield to="action"}}
          </FlexRow>
        {{/if}}
      </FlexRow>
      {{#if this.hasBorder}}
        <FlexRow class="divider" data-test-spds-container-card-header-divider />
      {{/if}}
    </FlexColumn>
  </template>
}

export const CARD_HEADER_METADATA = SpdsContainerCardHeader.metadata;
